import React, {useContext} from "react";
import "./StartupProjects.scss";
import {bigProjects} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import projectsBanner from "../../assets/images/programmer.svg";

export default function StartupProject() {
  function openUrlInNewTab(url) {
    if (!url || url === "#") {
      return;
    }
    var win = window.open(url, "_blank");
    if (win) win.focus();
  }

  const {isDark} = useContext(StyleContext);
  if (!bigProjects.display) {
    return null;
  }

  return (
    <div className="main" id="projects">
      <div>
        <div className="projects-banner">
          <div className="projects-banner-text">
            <h1 className={isDark ? "dark-mode skills-heading" : "skills-heading"}>
              <i className="fas fa-folder-open section-heading-icon" aria-hidden="true"></i>
              {bigProjects.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode project-subtitle"
                  : "subTitle project-subtitle"
              }
            >
              {bigProjects.subtitle}
            </p>
          </div>
          <div className="projects-banner-image">
            <img alt="Projects banner" src={projectsBanner}></img>
          </div>
        </div>

        <div className="projects-container">
          {bigProjects.projects.map((project, i) => {
            return (
              <div
                key={i}
                className={
                  isDark
                    ? "dark-mode project-card project-card-dark"
                    : "project-card project-card-light"
                }
              >
                {project.icon && (
                  <div className="project-image-icon-div">
                    <i className={`project-card-icon ${project.icon}`} aria-hidden="true"></i>
                  </div>
                )}
                <div className="project-detail">
                  <h5
                    className={isDark ? "dark-mode card-title" : "card-title"}
                  >
                    {project.icon && (
                      <i className={`project-title-icon ${project.icon}`}></i>
                    )}
                    {project.projectName}
                  </h5>
                  {project.projectMeta && (
                    <p
                      className={
                        isDark ? "dark-mode card-meta" : "card-meta"
                      }
                    >
                      {project.projectMeta}
                    </p>
                  )}
                  <p
                    className={
                      isDark ? "dark-mode card-subtitle" : "card-subtitle"
                    }
                  >
                    {project.projectDesc}
                  </p>
                  {project.techStackIcons && project.techStackIcons.length > 0 && (
                    <div className="project-tech-icons" aria-label="Project technologies">
                      {project.techStackIcons.map((techIcon, iconIndex) => (
                        <i key={`${project.projectName}-icon-${iconIndex}`} className={techIcon}></i>
                      ))}
                    </div>
                  )}
                  {project.footerLink ? (
                    <div className="project-card-footer">
                      {project.footerLink.map((link, i) => {
                        return (
                          <span
                            key={i}
                            className={
                              isDark ? "dark-mode project-tag" : "project-tag"
                            }
                            onClick={() => openUrlInNewTab(link.url)}
                          >
                            {link.name}
                          </span>
                        );
                      })}
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
